export default "<button mat-icon-button (click)=\"openSearchDialog.next()\">\n  <mat-icon>search</mat-icon>\n</button>";